import React from 'react'
import './ColorPickerSettings.scss'
import { ArrowForwardIos } from '@material-ui/icons'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Card, CardContent, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import { ColorPicker } from '@components/common'
import Comps from '@engine/comps'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { donutChartThemeColorHelper } from '../../../engine/utils/donutChartHelper'

const DONUT_CHART_GLOBAL_COLOR_TAB = ['Studio', 'One Bedroom', 'Two Bedroom', 'Three Bedroom', 'Four Bedroom', 'Five Bedroom', 'Six Bedroom', 'Seven Bedroom', 'Eight Bedroom']

export class ColorPickerSettings extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      summaryExpansionPanelOpen: false,
      subjectExpansionPanelOpen: false,
      comparableExpansionPanelOpen: false,
      donutChartExpansionPanelOpen: false,
      isExpandAll: true
    }
  }

  handleColorChange = (color, namespace, flag) => {
    this.props.editThemeColors({ [namespace]: color, action: flag })
  }

  handleDonutChartColorChange = (color, namespace, flag) => {
    this.props.editDonutChartColors({ [namespace]: color, action: flag })
  }

  handleExpandAll = expand => {
    this.setState({ ...this.state, summaryExpansionPanelOpen: expand, subjectExpansionPanelOpen: expand, comparableExpansionPanelOpen: expand, donutChartExpansionPanelOpen: expand, isExpandAll: !expand })
    // this.checkExpandAll()
  }

  checkExpandAll = () => {
    const isExpandAllState = (this.state.summaryExpansionPanelOpen && this.state.subjectExpansionPanelOpen && this.state.comparableExpansionPanelOpen)
    this.setState({ ...this.state, isExpandAll: !isExpandAllState })
  }

  handleSummaryExpansionChange = () => {
    this.setState({ ...this.state, summaryExpansionPanelOpen: !this.state.summaryExpansionPanelOpen }, () => this.checkExpandAll())
  }

  handleSubjectExpansionChange = () => {
    this.setState({ ...this.state, subjectExpansionPanelOpen: !this.state.subjectExpansionPanelOpen }, () => this.checkExpandAll())
  }

  handleComparableExpansionChange = () => {
    this.setState({ ...this.state, comparableExpansionPanelOpen: !this.state.comparableExpansionPanelOpen }, () => this.checkExpandAll())
  }

  handleDonutChartExpansionChange = () => {
    this.setState({ ...this.state, donutChartExpansionPanelOpen: !this.state.donutChartExpansionPanelOpen }, () => this.checkExpandAll())
  }

  render() {
    const { templateName, toggleSettings: { templateType }, themeColors, donutChartThemeColors, compsWithSubjectProperty } = this.props
    const { summaryExpansionPanelOpen, subjectExpansionPanelOpen, comparableExpansionPanelOpen, donutChartExpansionPanelOpen } = this.state
    const donutChartColors = donutChartThemeColorHelper(donutChartThemeColors)
    const ignoreListWhen = ['T6', 'S2']
    const globalColorList = [
      {
        name: 'Main color',
        key: 'globalColor',
        defaultColor: themeColors.globalColor,
        subName: '(Subject Property, Section Heading)'
      },
      {
        name: 'Sub Color',
        key: 'globalSubColor',
        defaultColor: themeColors.globalSubColor,
        subName: templateName === 'salesComps' ? '(Comparable Property)' : '(Title 2, Comparable Property)'
      }
    ]

    const summarySubjectColorList = [
      {
        name: 'Background',
        key: 'summarySubjectBackgroundColor',
        defaultColor: themeColors.summarySubjectBackgroundColor
      },
      {
        name: 'Text',
        key: 'summarySubjectTextColor',
        defaultColor: themeColors.summarySubjectTextColor
      },
      {
        name: 'Border',
        key: 'summarySubjectBorderColor',
        defaultColor: themeColors.summarySubjectBorderColor
      }
    ]
    const summaryComparableColorList = [
      {
        name: 'Background',
        key: 'summaryComparableBackgroundColor',
        defaultColor: themeColors.summaryComparableBackgroundColor
      },
      {
        name: 'Text',
        key: 'summaryComparableTextColor',
        defaultColor: themeColors.summaryComparableTextColor
      },
      {
        name: 'Border',
        key: 'summaryComparableBorderColor',
        defaultColor: themeColors.summaryComparableBorderColor
      }
    ]

    const subjectColorList = [
      {
        name: 'Property name',
        key: 'subjectPropertyNameColor',
        defaultColor: themeColors.subjectPropertyNameColor
      },
      {
        name: 'Section heading',
        key: 'subjectSectionHeadingColor',
        defaultColor: themeColors.subjectSectionHeadingColor
      },
      {
        name: 'Text bullet symbols',
        key: 'subjectTextbulletColor',
        defaultColor: themeColors.subjectTextbulletColor
      }
    ]
    const subjectMarkerColorList = [
      {
        name: 'Background',
        key: 'subjectMarkerBackgroundColor',
        defaultColor: themeColors.subjectMarkerBackgroundColor
      },
      {
        name: 'Text',
        key: 'subjectMarkerTextColor',
        defaultColor: themeColors.subjectMarkerTextColor
      },
      {
        name: 'Border',
        key: 'subjectMarkerBorderColor',
        defaultColor: themeColors.subjectMarkerBorderColor
      }
    ]

    const comparableColorList = [
      {
        name: 'Property name',
        key: 'comparablePropertyNameColor',
        defaultColor: themeColors.comparablePropertyNameColor
      },
      {
        name: 'Section heading',
        key: 'comparableSectionHeadingColor',
        defaultColor: themeColors.comparableSectionHeadingColor
      },
      {
        name: 'Text bullet symbols',
        key: 'comparableTextbulletColor',
        defaultColor: themeColors.comparableTextbulletColor
      }
    ]
    const comparableMarkerColorList = [
      {
        name: 'Background',
        key: 'comparableMarkerBackgroundColor',
        defaultColor: themeColors.comparableMarkerBackgroundColor
      },
      {
        name: 'Text',
        key: 'comparableMarkerTextColor',
        defaultColor: themeColors.comparableMarkerTextColor
      },
      {
        name: 'Border',
        key: 'comparableMarkerBorderColor',
        defaultColor: themeColors.comparableMarkerBorderColor
      }
    ]

    if (templateName === 'salesComps') {
      subjectColorList.pop()
      comparableColorList.pop()
    }

    if (templateType === 'T3') {
      subjectColorList.splice(-2, 2)
      comparableColorList.splice(-2, 2)
    }

    return (
      <div className="color-picker-settings-container">
        <div data-testid="color-picker-tab" className="color-picker-tab">
          <div className="color-picker-title-container">
            <ArrowForwardIos className="arrow-forward" />
            <div className="color-picker-title">Color Theme</div>
          </div>

          <Card className="color-picker-globalcolor-tab">
            <CardContent className="color-picker-padding5px">
              <div className="panelTitle">GLOBAL COLORS</div>
              <div className="global-color-row">
                {globalColorList.map((obj, index) => (
                  <div key={index} className="custom-color-row">
                    <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                  </div>
                ))
                }
              </div>
            </CardContent>
          </Card>

          <div className="color-picker-customize">
            <div className="customiseTitle">Customize</div>
            {this.state.isExpandAll && <div className="expandTitle" data-testid="expandAll" onClick={() => this.handleExpandAll(true)}>Expand All</div>}
            {!this.state.isExpandAll && <div className="expandTitle" onClick={() => this.handleExpandAll(false)}>Collapse All</div>}
          </div>
          <Accordion className={`${summaryExpansionPanelOpen ? '' : 'expansion-panel-color-picker'}`} expanded={summaryExpansionPanelOpen}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              data-testid="summaryExpansionPanel"
              onClick={this.handleSummaryExpansionChange}
            >
              <div className="panelTitle">PROPERTY SUMMARY</div>
            </AccordionSummary>
            <AccordionDetails className="expansionPanel" data-testid="summaryExpansionPanelDetails">
              {compsWithSubjectProperty && (
                <div className="global-color-row-bottom">
                  <div className="custom-color-row">
                    <ColorPicker
                      colorPickerObj={{
                        name: 'Row background',
                        key: 'summaryRowBackgroundColor',
                        defaultColor: themeColors.summaryRowBackgroundColor
                      }}
                      handleColorChange={this.handleColorChange} />
                  </div>
                </div>
              )}
              {compsWithSubjectProperty && (
                <>
                  <div className="panelTitle">Marker-Subject</div>
                  <div className="global-color-row-bottom">
                    {summarySubjectColorList.map((obj, index) => (
                      <div key={index} className="custom-color-row">
                        <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                      </div>
                    ))
                    }
                  </div>
                </>
              )}
              <div className="panelTitle">Marker-Comparable</div>
              <div className="global-color-row">
                {summaryComparableColorList.map((obj, index) => (
                  <div key={index} className="custom-color-row">
                    <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                  </div>
                ))
                }
              </div>
            </AccordionDetails>
          </Accordion>

          {!ignoreListWhen.includes(templateType) && compsWithSubjectProperty && (
            <Accordion className={`${subjectExpansionPanelOpen ? '' : 'expansion-panel-color-picker'}`} expanded={subjectExpansionPanelOpen}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                onClick={this.handleSubjectExpansionChange}
                data-testid="subjectExpansionPanel"
              >
                <div className="panelTitle">SUBJECT PROPERTY</div>
              </AccordionSummary>
              <AccordionDetails className="expansionPanel" data-testid="subjectExpansionPanelDetails">
                <div className="global-color-row-bottom">
                  {subjectColorList.map((obj, index) => (
                    <div key={index} className="custom-color-row">
                      <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                    </div>
                  ))
                  }
                </div>
                <div className="panelTitle">Marker Icon</div>
                <div className="global-color-row">
                  {subjectMarkerColorList.map((obj, index) => (
                    <div key={index} className="custom-color-row">
                      <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                    </div>
                  ))
                  }
                </div>
              </AccordionDetails>
            </Accordion>
          ) }
          {!ignoreListWhen.includes(templateType) && (
            <Accordion className={`${comparableExpansionPanelOpen ? '' : 'expansion-panel-color-picker'}`} expanded={comparableExpansionPanelOpen}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                onClick={this.handleComparableExpansionChange}
                data-testid="comparableExpansionPanel"
              >
                <div className="panelTitle">COMPARABLE PROPERTY</div>
              </AccordionSummary>
              <AccordionDetails className="expansionPanel" data-testid="comparableExpansionPanelDetails">
                <div className="global-color-row-bottom">
                  {comparableColorList.map((obj, index) => (
                    <div key={index} className="custom-color-row">
                      <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                    </div>
                  ))
                  }
                </div>
                <div className="panelTitle">Marker Icon</div>
                <div className="global-color-row">
                  {comparableMarkerColorList.map((obj, index) => (
                    <div key={index} className="custom-color-row">
                      <ColorPicker colorPickerObj={obj} displayLeft={Boolean(index % 2)} handleColorChange={this.handleColorChange} />
                    </div>
                  ))
                  }
                </div>
              </AccordionDetails>
            </Accordion>
          )}
          {templateName !== 'salesComps' && !ignoreListWhen.includes(templateType) && (
            <Accordion className={`${donutChartExpansionPanelOpen ? '' : 'expansion-panel-color-picker'}`} expanded={donutChartExpansionPanelOpen}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                onClick={this.handleDonutChartExpansionChange}
                data-testid="donutChartExpansionPanel"
              >
                <div className="panelTitle">DONUT CHART</div>
              </AccordionSummary>
              <AccordionDetails className="expansionPanel" data-testid="donutChartExpansionPanelDetails">
                <div className="global-color-column">
                  {DONUT_CHART_GLOBAL_COLOR_TAB.map((globalUnitType, index) =>
                    Object.keys(donutChartColors).includes(globalUnitType) &&
                      <div key={index}>
                        <div key={index} className="custom-color-row">
                          <ColorPicker colorPickerObj={{ name: globalUnitType, key: globalUnitType, defaultColor: donutChartThemeColors[globalUnitType] }}
                          displayLeft={false} handleColorChange={this.handleDonutChartColorChange} />
                        </div>
                        <div className="global-color-row-bottom">
                        {globalUnitType !== 'Studio' && Object.keys(donutChartColors[globalUnitType]).sort()
                        .map((unitType, i) =>
                          <div key={i} className="custom-color-row">
                            <ColorPicker colorPickerObj={{ name: unitType.replace('Bedroom', 'Bed'), key: unitType, defaultColor: donutChartThemeColors[unitType] }}
                            displayLeft={Boolean(i % 2)} handleColorChange={this.handleDonutChartColorChange} />
                          </div>
                        )}
                      </div>
                      </div>
                      )}
                  </div>
              </AccordionDetails>
            </Accordion>
          )}
        </div >
      </div >
    )
  }
}

ColorPickerSettings.propTypes = {
  donutChartThemeColors: PropTypes.object,
  templateName: PropTypes.string,
  toggleSettings: PropTypes.shape({
    templateType: PropTypes.string,
    hasBranding: PropTypes.bool,
    hasNotes: PropTypes.bool,
    hasAmenities: PropTypes.bool
  }),
  themeColors: PropTypes.object,
  editThemeColors: PropTypes.func,
  editDonutChartColors: PropTypes.func,
  compsWithSubjectProperty: PropTypes.bool
}

const mapStateToProps = state => ({
  toggleSettings: Comps.selectors.comps.toggleSettings(state),
  templateName: Comps.selectors.comps.templateName(state),
  themeColors: Comps.selectors.comps.themeColors(state),
  compsWithSubjectProperty: Comps.selectors.comps.compsWithSubjectProperty(state)
})

const mapDispatchToProps = {
  editThemeColors: Comps.actions.editThemeColors,
  editDonutChartColors: Comps.actions.editDonutChartColors
}

export default connect(mapStateToProps, mapDispatchToProps)(ColorPickerSettings)

